import React, { Component } from 'react';
import TableC from '../../../../basicElement/TableC';
import format from '../../../../shared/format';

class ServerFeeResolve extends Component {
    getServerColumns = () => {
        const { names } = this.props;
        const columns = [{
            title: names.num,
            dataIndex: 'num',
            key: 'num',
            width: 100,
        }, {
            title: names.resolve,
            dataIndex: 'resolve',
            key: 'resolve',
        }, {
            title: names.amount,
            dataIndex: 'amount',
            key: 'amount',
            width: 360,
            render: text => format('money', text),
        }];
        return columns;
    }

    render() {
        const { data, names } = this.props;
        return (
            <div>
                <div style={{ margin: '10px 0', fontWeight: 'bold' }}>{names.amount}</div>
                <TableC
                    data={data}
                    columns={this.getServerColumns()}
                    className="quotation_serverFeeResolve"
                />
            </div>
        );
    }
}

export default ServerFeeResolve;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Total/Table/Resolve.js